import { CampaignDrip } from "../../model/campaign/CampaignDrip";
import { CreateCampaignDripDto } from "../../model/campaign/dto/CreateCampaignDripDto";
import { UpdateCampaignDripDto } from "../../model/campaign/dto/UpdateCampaignDripDto";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { AtiraApi } from "../AxiosClient";

export class CampaignAxios {
  static createCampaign(dto: CreateCampaignDripDto) {
    return AtiraApi.post("/campaigns/create", dto).then(({ data }) => data);
  }

  static getCampaigns(dto: GenericWithUserId) {
    return AtiraApi.post<CampaignDrip[]>("/campaigns", dto).then(
      ({ data }) => data,
    );
  }

  static updateCampaign(dto: UpdateCampaignDripDto) {
    return AtiraApi.patch(`/campaigns/${dto.campaignId}`, dto).then(
      ({ data }) => data,
    );
  }
}
